import React, { useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SuggestionToast = ({ text, delay, onClick, onToastClose }) => {
  useEffect(() => {    
    const timer = setTimeout(() => {
      toast.success(
        <div className="flex flex-col" onClick={onClick}>
          <p className="text-base">Example prompt to ask Deli</p>
          <p className="font-semibold">{text}</p>
        </div>,
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          closeButton: false,
          icon: false,
          pauseOnFocusLoss: false,
          style: {
            background: "#fff",
            color: "#101828",
          },
          onClose: () => {
            onToastClose();
          }
        }
      );
    }, delay);

    return () => clearTimeout(timer);
  }, [delay, text, onClick, onToastClose]);

  return null;
};

export default SuggestionToast;
